module.exports = __webpack_public_path__ + "img/web3icon12.02238ab1.png";